var map = {
	"./arrow-down.svg": 80698,
	"./arrow-right.svg": 42076,
	"./check-completed.svg": 26678,
	"./check-incompleted.svg": 52473,
	"./check-svgrepo-com.svg": 93235,
	"./checkbox-agreement-checked.svg": 83874,
	"./checkbox-agreement-unchecked.svg": 90553,
	"./checkbox-checked.svg": 95957,
	"./checkbox-unchecked.svg": 33730,
	"./clock.svg": 60236,
	"./ic-edit-primary.svg": 84034,
	"./ic-edit.svg": 2623,
	"./ic_appreciation.svg": 944,
	"./ic_appreciation_primary.svg": 41931,
	"./ic_browse.svg": 18083,
	"./ic_document.svg": 19610,
	"./ic_earn.svg": 19743,
	"./ic_exit.svg": 17513,
	"./ic_income.svg": 83824,
	"./ic_income_primary.svg": 87755,
	"./ic_inflation.svg": 72001,
	"./ic_inflation_primary.svg": 38702,
	"./ic_purchase.svg": 38012,
	"./ic_wealth.svg": 97614,
	"./ic_wealth_primary.svg": 90597,
	"./info-circle.svg": 97603,
	"./info-outlined.svg": 66649,
	"./instant-disabled.svg": 98406,
	"./instant.svg": 54217,
	"./language.svg": 93024,
	"./location.svg": 9195,
	"./locked.svg": 70916,
	"./login.svg": 5253,
	"./radio-checked.svg": 71479,
	"./radio-disabled.svg": 59660,
	"./radio-unchecked.svg": 24816,
	"./regular.svg": 58530,
	"./transaction.svg": 48074,
	"./view-more-icon.svg": 48877,
	"./warning.svg": 6426
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 31894;